import PropTypes from 'prop-types';
import _ from 'lodash';
import Modal from '../modal/Modal';
import { SectionTitle } from '../typography/Heading';
import Image from '../image/Image';
import styles from './modal-with-header.module.less';

const ModalWithHeader = (props) => {
    const { title, onRequestClose, children, titleClass = '' } = props;

    const expandingProps = _.omit(props, ['title', 'titleClass', 'children']);

    const onRequestCloseModal = () => {
        onRequestClose();
    };

    return (
        <Modal
            className={styles.paymentModalContent}
            overlayClassName={styles.paymentModalOverlay}
            onRequestClose={onRequestCloseModal}
            containerClassName={styles.innerModalContainer}
            {...expandingProps}
        >
            <button onClick={onRequestCloseModal} className={styles.closeButton}>
                <Image src="/public/images/close.png" alt="Lukk" />
            </button>
            <div className={[styles.topContainer, titleClass].join(' ')}>
                <SectionTitle className={styles.title}>{title}</SectionTitle>
            </div>
            <div className={styles.bottomContainer}>{children}</div>
        </Modal>
    );
};

ModalWithHeader.defaultProps = {
    titleClass: '',
};

ModalWithHeader.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    titleClass: PropTypes.string,
    children: PropTypes.node,
};

export default ModalWithHeader;
